<template>
  <ShowDriverCommentModal/>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="this.searchText = '';fetchDrivers()">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Wyszukaj w panelu" @input="fetchDrivers">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row py-3">
      <div class="d-lg-flex justify-content-between">
        <h5 class="fw-bold">
          KIEROWCY
        </h5>
        <div class="d-flex justify-content-between my-4">
          <router-link :to="{ name: 'DriverAdd' }" class="btn btn-primary">
            Dodaj kierowcę
          </router-link>
          <router-link :to="{ name: 'DriverUnasignedListing' }" class="btn btn-primary">
            Poczekalnia kierowców
          </router-link>
        </div>

        <div class="font-weight-bold">
          {{ pageInfo.currentPage }} / {{ pageInfo.allPages }}
        </div>
        <div>
          <button class="btn btn-primary mx-1" @click="previousPage"><i class="fa-solid fa-circle-arrow-left"></i></button>
          <button class="btn btn-primary mx-1" @click="nextPage"><i class="fa-solid fa-circle-arrow-right"></i></button>
        </div>
      </div>
    </div>
    <table class="table table-responsive overflow-scroll mt-3" style="min-width: 1200px;">
      <thead>
      <tr>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Imię i nazwisko
        </td>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Kontakt
        </td>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Akcje
        </td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="driver in drivers" :key="driver.id">
        <td style="width: 200px;">
          <DriverCell :given-driver="driver"/>
        </td>
        <td style="width: 200px;">
          <ContactCell :phone="driver.phoneNumber" email=""/>
        </td>
        <td>
          <button v-if="canUserDeleteDrivers" @click="deleteDriver(driver.id)" class="btn btn-sm btn-danger mx-2">
            Usuń
          </button>
          <router-link :to="{ name: 'EditDriver', params: { id: driver.id }} ">
            <button class="btn btn-sm btn-primary mx-2">
              Edytuj
            </button>
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import DriverCell from '@/components/DriverListing/DriverCell.vue'
import ContactCell from '@/components/ContactCell'
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import eventKinds from '@/modules/events/eventKinds'
import { mapActions } from 'vuex'
import ShowDriverCommentModal from '@/components/TasksCalendar/Modals/ShowDriverCommentModal.vue'

export default {
  name: 'DriverListing',
  components: { ShowDriverCommentModal, RefreshButton, ContactCell, DriverCell, Navbar },
  data () {
    return {
      allDrivers: [],
      drivers: null,
      perPage: 150,
      page: 1,
      paginatedData: [],
      isSearchVisible: false,
      searchText: '',
      mailings: [],
      pageInfo: 0,
      canUserDeleteDrivers: true,
      refreshing: false,
      controller: new AbortController()
    }
  },
  created () {
    emitter.on('refreshed', this.refresh)

    emitter.on(eventKinds.calendarShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.storehouseShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.tasksListShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.placesShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.reportsShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.usersShown, () => {
      this.controller.abort()
    })

    this.$store.commit('setInitialCalendarLoading', true)
    window.addEventListener('scroll', this.scrollFunction)
    emitter.on('calendarVehicleChanged', this.fetchDrivers)
    emitter.on('trioCommentModified', this.fetchDrivers)

    this.fetchDrivers()
    this.getMailing()

    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

    axios.get(`${process.env.VUE_APP_API_BASE_URL}User`, config).then(response => {
      const currentUser = response.data.filter(user => user.name === localStorage.getItem('username'))[0]

      if (!currentUser.permission.canRemoveDrivers && !currentUser.permission.canEditDrivers) {
        this.canUserDeleteDrivers = false
      }
    })
  },
  methods: {
    refresh () {
      this.fetchDrivers()
    },

    async fetchDrivers () {
      const distantFuture = new Date(8640000000000000)
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }, signal: this.controller.signal }
      try {
        this.refreshing = true
        this.allDrivers = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, config)).data
        this.drivers = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, config)).data.sort((a, b) => {
          let plannedDepartureA = a.plannedDepartureDate ? new Date(a.plannedDepartureDate) : distantFuture
          let plannedDepartureB = b.plannedDepartureDate ? new Date(b.plannedDepartureDate) : distantFuture

          return plannedDepartureA.getTime() - plannedDepartureB.getTime()
        }).slice((this.page - 1) * this.perPage, this.page * this.perPage)

        if (this.drivers.length === 0) {
          this.page = 0
          this.fetchDrivers()
        }

        this.pageInfo = {
          currentPage: this.page,
          allPages: Math.ceil(this.allDrivers.length / this.perPage)
        }

        if (this.searchText !== '' && this.searchText.length >= 2) {
          this.allDrivers.forEach(x => {
            if (x.firstName == null) {
              x.firstName = ''
            }
            if (x.surname == null) {
              x.surname = ''
            }
          })
          this.drivers = this.allDrivers.filter(driver => `${driver.firstName.toLowerCase()} ${driver.surname.toLowerCase()}`.includes(this.searchText.toLowerCase()) || `${driver.surname.toLowerCase()} ${driver.firstName.toLowerCase()}`.includes(this.searchText.toLowerCase()))
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.refreshing = false
      }
    },
    deleteDriver (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      Swal.fire({
        title: 'Usunąć tego kierowcę?',
        text: 'Jesteś pewien że chcesz usunąć tego kierowcę?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Usuń'
      }).then((result) => {
        if (result.value) {
          axios.delete(`${process.env.VUE_APP_API_BASE_URL}Driver/${id}`, config).then(() => {
            Swal.fire('Pomyślnie usunięto kierowcę', '', 'success')
            this.fetchDrivers()
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    nextPage () {
      this.page++
      this.fetchDrivers()
    },
    previousPage () {
      if (this.page > 1) {
        this.page--
        this.fetchDrivers()
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    getMailing () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(process.env.VUE_APP_API_BASE_URL + 'NotificationRecipient', config)
        .then(response => {
          this.mailings = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
</style>
